export const list = [
  "All",
  "Game",
  "Live",
  "bgmi",
  "Viper",
  "Music",
  "Cricket",
  "Football",
  "UFC",
  "Yoga",
  "Laptops",
  "Mortal",
  "Lenovo",
  "iphone",
  "Technology",
  "Music",
  "Cricket",
  "Football",
  "UFC",
  "Yoga",
  "Laptops",
  "Mortal",
];

export const commentsData = [
  {
    name: "Jon",
    text: "lorem ipsum doerem jorem",
    replies: [
      {
        name: "Robb",
        text: "lorem ipsum doerem jorem",
        replies: [],
      },
      {
        name: "Theon",
        text: "lorem ipsum doerem jorem",
        replies: [
          {
            name: "Ramsay",
            text: "lorem ipsum doerem jorem",
            replies: [
              {
                name: "Sansa",
                text: "lorem ipsum doerem jorem",
                replies: [],
              },
            ],
          },
        ],
      },
      {
        name: "Danny",
        text: "lorem ipsum doerem jorem",
        replies: [],
      },
    ],
  },
  {
    name: "Sam",
    text: "lorem ipsum doerem jorem",
    replies: [],
  },
  {
    name: "Robb",
    text: "lorem ipsum doerem jorem",
    replies: [],
  },
  {
    name: "Arya",
    text: "lorem ipsum doerem jorem",
    replies: [
      {
        name: "Sam",
        text: "lorem ipsum doerem jorem",
        replies: [
          {
            name: "Jon",
            text: "lorem ipsum doerem jorem",
            replies: [
              {
                name: "Ned",
                text: "lorem ipsum doerem jorem",
                replies: [
                  {
                    name: "Jamie",
                    text: "lorem ipsum doerem jorem",
                    replies: [
                      {
                        name: "Robert",
                        text: "lorem ipsum doerem jorem",
                        replies: [],
                      },
                    ],
                  },
                  {
                    name: "Varys",
                    text: "lorem ipsum doerem jorem",
                    replies: [],
                  },
                  {
                    name: "Cersie",
                    text: "lorem ipsum doerem jorem",
                    replies: [
                      {
                        name: "Peter",
                        text: "lorem ipsum doerem jorem",
                        replies: [
                          {
                            name: "Arya",
                            text: "lorem ipsum doerem jorem",
                            replies: [],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: "Sansa",
        text: "lorem ipsum doerem jorem",
        replies: [
          {
            name: "Peter",
            text: "lorem ipsum doerem jorem",
            replies: [],
          },
        ],
      },
    ],
  },
  {
    name: "Sansa",
    text: "lorem ipsum doerem jorem",
    replies: [],
  },
  {
    name: "Stannis",
    text: "lorem ipsum doerem jorem",
    replies: [
      {
        name: "Catlyn",
        text: "lorem ipsum doerem jorem",
        replies: [],
      },
    ],
  },
  {
    name: "Joffery",
    text: "lorem ipsum doerem jorem",
    replies: [
      {
        name: "Olenna",
        text: "lorem ipsum doerem jorem",
        replies: [],
      },
      {
        name: "Margery",
        text: "lorem ipsum doerem jorem",
        replies: [],
      },
      {
        name: "Tyrion",
        text: "lorem ipsum doerem jorem",
        replies: [],
      },
    ],
  },
  {
    name: "Third Eye Raven",
    text: "lorem ipsum doerem jorem",
    replies: [
      {
        name: "Night King",
        text: "lorem ipsum doerem jorem",
        replies: [
          {
            name: "Arya",
            text: "lorem ipsum doerem jorem",
            replies: [],
          },
        ],
      },
    ],
  },
  {
    name: "D&D 🤡",
    text: "lorem ipsum doerem jorem",
    replies: [],
  },
];

var nameList = [
  "Time",
  "Past",
  "Future",
  "Dev",
  "Fly",
  "Flying",
  "Soar",
  "Soaring",
  "Power",
  "Falling",
  "Fall",
  "Jump",
  "Cliff",
  "Mountain",
  "Rend",
  "Red",
  "Blue",
  "Green",
  "Yellow",
  "Gold",
  "Demon",
  "Demonic",
  "Panda",
  "Cat",
  "Kitty",
  "Kitten",
  "Zero",
  "Memory",
  "Trooper",
  "XX",
  "Bandit",
  "Fear",
  "Light",
  "Glow",
  "Tread",
  "Deep",
  "Deeper",
  "Deepest",
  "Mine",
  "Your",
  "Worst",
  "Enemy",
  "Hostile",
  "Force",
  "Video",
  "Game",
  "Donkey",
  "Mule",
  "Colt",
  "Cult",
  "Cultist",
  "Magnum",
  "Gun",
  "Assault",
  "Recon",
  "Trap",
  "Trapper",
  "Redeem",
  "Code",
  "Script",
  "Writer",
  "Near",
  "Close",
  "Open",
  "Cube",
  "Circle",
  "Geo",
  "Genome",
  "Germ",
  "Spaz",
  "Shot",
  "Echo",
  "Beta",
  "Alpha",
  "Gamma",
  "Omega",
  "Seal",
  "Squid",
  "Money",
  "Cash",
  "Lord",
  "King",
  "Duke",
  "Rest",
  "Fire",
  "Flame",
  "Morrow",
  "Break",
  "Breaker",
  "Numb",
  "Ice",
  "Cold",
  "Rotten",
  "Sick",
  "Sickly",
  "Janitor",
  "Camel",
  "Rooster",
  "Sand",
  "Desert",
  "Dessert",
  "Hurdle",
  "Racer",
  "Eraser",
  "Erase",
  "Big",
  "Small",
  "Short",
  "Tall",
  "Sith",
  "Bounty",
  "Hunter",
  "Cracked",
  "Broken",
  "Sad",
  "Happy",
  "Joy",
  "Joyful",
  "Crimson",
  "Destiny",
  "Deceit",
  "Lies",
  "Lie",
  "Honest",
  "Destined",
  "Bloxxer",
  "Hawk",
  "Eagle",
  "Hawker",
  "Walker",
  "Zombie",
  "Sarge",
  "Capt",
  "Captain",
  "Punch",
  "One",
  "Two",
  "Uno",
  "Slice",
  "Slash",
  "Melt",
  "Melted",
  "Melting",
  "Fell",
  "Wolf",
  "Hound",
  "Legacy",
  "Sharp",
  "Dead",
  "Mew",
  "Chuckle",
  "Bubba",
  "Bubble",
  "Sandwich",
  "Smasher",
  "Extreme",
  "Multi",
  "Universe",
  "Ultimate",
  "Death",
  "Ready",
  "Monkey",
  "Elevator",
  "Wrench",
  "Grease",
  "Head",
  "Theme",
  "Grand",
  "Cool",
  "Kid",
  "Boy",
  "Girl",
  "Vortex",
  "Paradox",
];

export function generateRandomName() {
  return nameList[Math.floor(Math.random() * nameList.length)];
}

export function makeRandomMessage(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}
